import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@app/shared/services/loader.service';

interface FinanceTile {
  title: string;
  icon: string;
  route?: string;
  comingSoon: boolean;
}

interface PreviewRow {
  dateRange: string;
  action: string;
  highlight: boolean;
}

@Component({
  selector: 'app-finance-dashboard',
  templateUrl: './finance-dashboard.component.html',
  styleUrl: './finance-dashboard.component.scss',
})
export class FinanceDashboardComponent {
  readonly previewRows: PreviewRow[] = this.buildPreviewRows();

  tiles: FinanceTile[] = [
    {
      title: 'D&T India Recharge Recovery',
      icon: 'event_note',
      route: '/finance/recharge-recovery',
      comingSoon: false,
    },
    {
      title: 'Headcount Report',
      icon: 'description',
      comingSoon: true,
    },
    {
      title: 'Finance Details',
      icon: 'monitoring',
      route: '/finance/details',
      comingSoon: false,
    },
    {
      title: 'Onboarding',
      icon: 'person_add',
      comingSoon: true,
    },
    {
      title: 'Approval Status',
      icon: 'verified_user',
      comingSoon: true,
    },
    {
      title: 'Archives',
      icon: 'folder',
      comingSoon: true,
    },
  ];

  constructor(
    private readonly router: Router,
    private readonly loaderService: LoaderService,
  ) {
    this.loaderService.hide();
  }

  onTileClick(tile: FinanceTile): void {
    if (tile.comingSoon || !tile.route) {
      return;
    }
    this.router.navigate([tile.route]);
  }

  private buildPreviewRows(): PreviewRow[] {
    const now = new Date();
    const year = now.getFullYear();
    const monthAbbr = now.toLocaleString('en-US', { month: 'short' });
    const yy = String(year % 100).padStart(2, '0');
    const deadline = (day: number) => `${day}-${monthAbbr}-${yy}`;
    const range = (from: number, to: number) =>
      `${String(from).padStart(2, '0')} ${monthAbbr} ${year} – ${String(to).padStart(2, '0')} ${monthAbbr} ${year}`;

    return [
      { dateRange: range(1, 7), action: 'FAs to connect with ID&T Leader/DRs for allocation updates.', highlight: false },
      { dateRange: deadline(7), action: 'Amendments to be shared with D&T India Ops Team.', highlight: true },
      { dateRange: range(8, 10), action: 'FAs to share the resource tracker with Onshore POCs/Finance for confirmation.', highlight: false },
      { dateRange: deadline(15), action: 'Freeze on any new joinee assignments.', highlight: true },
      { dateRange: range(16, 17), action: 'FAs to prepare the final cost sheets based on received updates.', highlight: false },
    ];
  }
}
